import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/hero"
import Services from "../components/services"
import GuidePreview from "../components/guide-preview"
import TrendsPreview from "../components/trends-preview"
import AboutPanel from "../components/about-panel"
import Testimonials from "../components/testimonials"
import ThemeProvider from "@material-ui/styles/ThemeProvider"
import theme from "../theme"
import AppsPanel from "../components/apps-panel"

const IndexPage = () => (
  <React.Fragment>
    <ThemeProvider theme={theme}>
      <Layout>
        <SEO
          title="Weekly Planner for School, Study & Family Routines"
          description="Build a visual weekly schedule for learning, practice and play. Plan with AI, explore activity ideas and share your calendar with family or parents."
        />
        <Hero />
        <TrendsPreview />
        <Services />
        {/* <AboutPanel />
        <AppsPanel /> */}
        {/* <Testimonials /> */}
        <GuidePreview />
      </Layout>
    </ThemeProvider>
  </React.Fragment>
)

export default IndexPage
